var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['review-stars', { small: _vm.small }]},_vm._l((_vm.maxRating),function(n){return _c('span',{key:n,class:{ full: n <= _vm.starCount }},[_vm._v(" ★ ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }